import { createContext, type Dispatch, type SetStateAction } from "react";
import { UrlUpdateType } from "use-query-params";
import {
    BillByCounterpartySortValue,
    BillsByCounterpartyItem,
} from "@common/types/bill";
import { SortByCounterparty } from "./useSortByCounterparty";

export interface BillsByCounterpartyTableContextValue {
    currentPage: number;
    totalPages: number;
    counterpartiesCount: number;
    setPage:
        | Dispatch<SetStateAction<number>>
        | ((
              newValue: number | null | undefined,
              updateType?: UrlUpdateType,
          ) => void);
    handleSortChange: SortByCounterparty["handleSortChange"];
    currentSort: SortByCounterparty["currentSort"];
    isLoading: boolean;
    data?: BillsByCounterpartyItem[];
}

const defaultValue: BillsByCounterpartyTableContextValue = {
    currentPage: 0,
    totalPages: 0,
    counterpartiesCount: 0,
    setPage: () => {},
    handleSortChange: () => {},
    currentSort: BillByCounterpartySortValue.OPEN_DESC,
    isLoading: false,
};

export const BillsByCounterpartyTableContext =
    createContext<BillsByCounterpartyTableContextValue>(defaultValue);
